"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [["будь то", "или"], ["возможно", "а может быть"], ["возможно", "возможно"], ["достаточно", "чтобы"], ["едва", "как"], ["ежели", "то"], ["если говорить о", "то"], ["если и не", "то"], ["если не", "то"], ["если", "то"], ["мало того что", "еще и"], ["мало того, что", "еще и"], ["не сказать чтобы", "но"], ["не сказать, чтобы", "но"], ["не столько", "сколько"], ["не то чтобы", "но"], ["не только не", "но и"], ["стоило", "как"], ["так как", "то"], ["только", "как"], ["хоть бы", "а то"], ["хоть", "хоть"], ["хотя", "но"], ["чем", "лучше бы"], ["чем", "тем"], ["что касается", "то"]];
};